import {
    REQUEST_DONATION_GROUP_LIST,
    REQUEST_DONATION_GROUP
} from './mutation-types'

import axiosInst from '@/utility/axiosInst';

export default {
  requestDonationGroupList({commit}, payload) {
    const {currentPage, searchType, searchWord} = payload
    return axiosInst.springAxiosInst.get("/admin/donation-group/list", {
      params: {
        page: currentPage,
        searchType: searchType,
        searchWord : searchWord
      }
    }).then((res) => {
      commit(REQUEST_DONATION_GROUP_LIST, res.data)
    })
  },

  requestDeleteDonationGroups({}, payload) {
    return axiosInst.springAxiosInst.post('/admin/donation-group/delete-donation-groups', payload)
    .then((res) => {
      return res.data
    })
  },

  requestSaveDonationGroup({}, payload) {
    return axiosInst.springAxiosInst.post("/admin/donation-group/save-donation-group", payload)
      .then((res) => {
        return res.data
      })
  },

  requestDonationGroup({commit}, donationGroupSeq) {
    return axiosInst.springAxiosInst.get(`/admin/donation-group/donation-group/${donationGroupSeq}`)
    .then((res) => {
      commit(REQUEST_DONATION_GROUP, res.data)
    })
  },

  requestEditorImageUpload({}, payload) {
    return axiosInst.springAxiosInst.post("/file/upload-editor-img", payload)
      .then((res) => {
        return res.data
      })
  }
}